<template>
  <div class="visit-room">
    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <div v-if="encounter">
      <div class="visit-room-header" v-if="!$vuetify.breakpoint.xsOnly">
        <v-chip v-if="roomIsStarted && !roomIsFinished && timer" label color="red darken-1" dark>
          {{ timer }}
        </v-chip>
        <span class="visit-room-header-select">{{ $t("visits.visitRoomWith") }} {{ encounter.practitioner.name }}</span>
        <div class="visit-room-header-bordered">
          <v-icon color="icon">mdi-calendar-blank</v-icon>
          <p>{{ dateFormated }}</p>
        </div>
        <div class="visit-room-header-bordered">
          <v-icon color="icon">mdi-clock-outline</v-icon>
          <p>{{ timeRange }}</p>
        </div>
      </div>
      <v-row class="visit-room-content" no-gutters>
        <VideoRoom v-if="!roomIsFinished && room" :call-time="timer" />
        <Summary class="visit-room-content-summary" v-if="roomIsFinished && room" :encounter="encounter" />
      </v-row>
    </div>
  </div>
</template>
<script>
import VideoRoom from "@/components/VideoRoom";
import { visitRoomMixin } from "@/mixins/visitRoom";
import Summary from "@/views/Patient/Visits/Summary";

export default {
  components: {
    VideoRoom,
    Summary,
  },
  mixins: [visitRoomMixin],
};
</script>

<style lang="scss" scoped>
.visit-room-content-summary {
  height: 100%;
}
.visit-room-content {
  height: 100%;
}
</style>
